<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12" class="design-iconfont">
    <path opacity=".01" transform="matrix(1 0 0 -1 0 12)" fill="#000" d="M0 0H12V12H0z" />
    <path d="M9.14646 7.14643C9.46144 7.46141 9.23835 7.99998 8.7929 7.99998L3.20712 7.99998C2.76167 7.99998 2.53859 7.4614 2.85357 7.14642L5.6465 4.35355C5.84177 4.15829 6.15835 4.15829 6.35361 4.35355L9.14646 7.14643Z" fill="#fff" />
</svg>
</template>